.errorContainer {
  color: var(--cont-color-common-fg-negative-bold);
  margin-left: 10px;
  margin-right: 10px;
}
